
      import API from "!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../vue-conf/dedup-scss.webpack.js!../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!../../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BreadcrumbSwitcherMenu.vue?vue&type=style&index=0&id=1e603ea5&scoped=true&lang=scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../vue-conf/dedup-scss.webpack.js!../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!../../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BreadcrumbSwitcherMenu.vue?vue&type=style&index=0&id=1e603ea5&scoped=true&lang=scss";
       export default content && content.locals ? content.locals : undefined;
